import { useState} from "react";

import { Route, Routes, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar";
import HomePage from "./components/HomePage";
import DownLoad from "./components/DownLoad";
import Premium from "./components/Premium";
import Support from "./components/Support";
import SignUp from "./components/SignUp";
import LogIn from "./components/LogIn";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";

function App() {
  const location = useLocation();
  const [openSideBar, setOpenSideBar] = useState(false);

  let supportPage = false;
  if (location.pathname === "/support") {
    supportPage = true;
  }

  const navLinks = [
    {
      link1: "Premium",
    },
    {
      link2: "Support",
    },
    {
      link3: "Download",
    },
    {
      link4: "Sign up",
    },
    {
      link5: "Log in",
    },
  ];

  return (
    <div>
      {location.pathname !== "/login" && location.pathname !== "/signup" && (
        <NavBar
          openSideBar={openSideBar}
          setOpenSideBar={setOpenSideBar}
          navLinks={navLinks}
          supportPage={supportPage}
        />
      )}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/support" element={<Support />} />
        <Route path="/download" element={<DownLoad />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<LogIn />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>

      {location.pathname !== "/login" && location.pathname !== "/signup" && (
        <Footer />
      )}
    </div>
  );
}

export default App;
